import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Loader
} from '../../../../neoverv';
import moment from 'moment';
import Autoload from '../../../../neoverv/Autoload';
import { browserName } from "react-device-detect";

import $ from 'jquery';
import {
  Table, 
  TableBody, 
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core';
import { showNotification } from '@mantine/notifications';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import { formatNumber } from '../../../../helpers/stringsManipulations';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import accounting from 'accounting';
import { Group } from '@mantine/core';
import imageCompression from 'browser-image-compression';
import { fetchTransactionsForRentalPayments } from '../../../../components/receiptTenantTransactionsApi';

var Setting = Autoload.Setting;
const { loader, checkEnvironment, errorHandlingForPDF } = Autoload.MainHelper;
const ref = React.createRef();

const Logo = "data:image/svg+xml;base64,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";

export class RentalPaymentsPdfTemplate extends Component {
  static propTypes = {
    prop: PropTypes,
  };

  tableHeadCellStyling = {
    color: 'rgb(114, 114, 147)',
    padding: '1mm',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    margin: '0px',
    fontSize: '7pt',
    lineHeight: '20px',
    border: '1px solid #DADAE6',
    height: '0px',
    textAlign: 'left',
    minWidth: '12.5%',
  }

  tableBodyCellStyling = {
    color: '#0e0e1d',
    padding: '1mm',
    fontWeight: '400',
    //whiteSpace: 'nowrap',
    minWidth: '12.5%',
    fontSize: '7pt',
    lineHeight: '20px',
    border: '1px solid #DADAE6',
    height: '0px',
    //minWidth: '40px',
  }

  // Inner table of the bank transactions assigned to a rental payment. Inline styles only: the
  // PDF is rendered from this div's HTML alone, without the page's stylesheets.
  transactionHeadCellStyling = {
    color: '#727293',
    fontSize: '6pt',
    fontWeight: '500',
    lineHeight: '12px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    padding: '0.8mm 1.5mm',
    borderBottom: '1px solid #DADAE6',
  }

  transactionBodyCellStyling = {
    color: '#0e0e1d',
    fontSize: '6.5pt',
    fontWeight: '400',
    lineHeight: '12px',
    verticalAlign: 'top',
    wordBreak: 'break-word',
    padding: '0.8mm 1.5mm',
    borderBottom: '1px solid #EDEDF5',
  }

  state = {
    transactionsByRentalPaymentId: {},
    transactionsIncomplete: false,
    totalNetRent: 0, 
    totalPrePayments: 0, 
    totalWarmRent: 0,
    allRents: [],
    rentalPayments: [],
    selectedTenant: [],
    selectedDateRange: {
      start: dayjs().startOf('year'),
      end: dayjs().endOf('year')
    },
    tenantOptions: [],
    orderBy: 'Monat',
    order: 'desc',
    customImageBase64: null,
    tenantEditView: false
  };

  componentDidMount(){
    let url = new URL(window.location.href);
    
    var loaderWhole = document.getElementById('hello-housing-loader');
    loaderWhole.style.display = 'block';
    var loaderBackground = document.getElementById('hh_loader_bg');
    var loader = document.getElementById('hh_loader_spinner');
    loaderBackground.style.background = 'white';
    loaderBackground.style.opacity = '1';
    loader.style.zIndex = '99999';

    this.setState({
      selectedTenant: JSON.parse(url.searchParams.get("selectedTenant")),
      selectedDateRange: JSON.parse(url.searchParams.get("selectedDateRange")),
      order: JSON.parse(url.searchParams.get("order")),
      orderBy: JSON.parse(url.searchParams.get("orderBy")),
      tenantEditView: JSON.parse(url.searchParams.get("tenantEditView")),
    }, ()=> {
      this.getAccountPicture();
    });

    
  }

  getAccountPicture=()=>{
    fetch(Autoload.Setting.account_api_baseurl + this.props.accountData.accountId +'/picture/download', 
    {
      method: 'GET',
      headers: {
        'Content-Type': 'octet-stream',
        'Authorization': Autoload.Utils.getAuthToken()
      }
    }).then(response => {
      response.blob()
      .then(async blob => {
        const options = {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 400,
          useWebWorker: true
        }
        try {
          let fileNew = new File([blob], "my_image.png",{type:"image/png", lastModified:new Date().getTime()});
          
          const compressedFile = await imageCompression(fileNew, options);
          console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
          console.log(`compressedFile size ${compressedFile.size / 1024} KB`); // smaller than maxSizeMB
          
          var reader = new FileReader();
          reader.readAsDataURL(compressedFile); 

          const setState=(base64)=>{
            this.setState({customImageBase64: base64 ? base64 : null});
          }
          
          reader.onloadend = function() {
            var base64data = reader.result;                
            console.log('base64data: ', base64data);
            setState(base64data);
          }
        } catch (error) {
          console.log('getAccountPicture: ', error);
        }

        setTimeout(() => {
          this.bind_rental_unit_list_data();
        }, 600);
      }).catch(e1=> console.log('getAccountPicture: error1: ', e1))
    }).catch(e=> console.log('getAccountPicture: error: ', e))
  }

  bind_rental_unit_list_data = () => {
    console.log('test_property: ', this.props.propertySelected);
    let propertyid = this.props.propertySelected && this.props.propertySelected.id;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rentalUnits?offset=0&fetch=100&propertyId=' + propertyid,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_list_rental_unit',
      null,
      false,
      '',
      {
        // 'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handle_get_list_rental_unit(response){
    if(response.status && response.statuscode === 200){
      let rentalUnits= response.result.map((rentalUnit)=> {
        rentalUnit.tenantsData=[];
        return rentalUnit;
      })
      this.setState({rentalUnits},()=>{
        response.result.map((rentalUnit, index)=> {
          Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url + 'tenants?offset=0&fetch=100&rentalUnitId=' + rentalUnit.id,
            'GET',
            null,
            null,
            false,
            true,
            false,
            this,
            'handle_get_list_rental_tenants',
            {rentalUnitId: rentalUnit.id, rentalUnitsLength: response.result.length, index},
            false,
            '',
            {
              //'Content-Type': 'application/json',
              Authorization: Autoload.Utils.getAuthToken(),
            }
          );
        });
      });
    }
  }

  handle_get_list_rental_tenants(response){
    let {rentalUnits} = this.state;
    if(response.status && response.statuscode === 200){
      rentalUnits.map((rentalUnit)=> {
        if(rentalUnit.id === response.other.rentalUnitId){
          rentalUnit.tenantsData = response.result;
        }
        return rentalUnit
      });
      this.setState({rentalUnits},()=> {
        if(response.other.rentalUnitsLength === (response.other.index+1)){
          let allTenantsList = this.state.tenantOptions;
          // let selectedTenantForModal = this.state.selectedTenantForModal;
          // let selectedTenant = this.state.selectedTenant;
          rentalUnits.map((rentalUnit)=>
          rentalUnit.tenantsData.map((tenant, index)=> {
            if(tenant.vacant === false){
              allTenantsList.push({
                value: tenant.id,
                label: `${tenant.fullName} (${rentalUnit.name})`, //(${tenant.in} - ${tenant.out ? tenant.out : 'nicht verfügbar'})
                name: tenant.fullName,
                tenantId: tenant.id,
                rentalUnit: rentalUnit.name,
                rentalUnitId: rentalUnit.id
              });
              // selectedTenantForModal.push(tenant.id);
              // selectedTenant.push(tenant.id);
            }
          }));

          this.setState({
            tenantOptions: allTenantsList
          },()=> this.evaluateRentalPayments());
        }
      });
    }
  }

  getRentalPayments=()=>{
    const {selectedDateRange} = this.state
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rentalPayments/property/' + this.props.propertySelected.id + 
      '?startDate='+ dayjs(selectedDateRange?.start).format('YYYY-MM-DDT00:00:00') + 
      '&endDate='+ dayjs(selectedDateRange?.end).format('YYYY-MM-DDT00:00:00'),
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_rental_payments',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_get_rental_payments(response){
    const {rentalUnits} = this.state;
    let {rentalPayments} = this.state;
    let allCheckedRentalPayments = 0;
    console.log('handle_get_rental_payments: ', rentalUnits);
    if(response.status && response.statuscode === 200){
      response.result.map((rentalPayment)=> {
        if((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) >= (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment)){
          allCheckedRentalPayments = allCheckedRentalPayments + 1;
        }
        if(rentalPayments.length === 0 || (rentalPayments.find((value)=> value.id === rentalPayment.id) === undefined)){
          let tenant = null;
          rentalUnits.map((rentalUnit)=>{
            let dataFound = rentalUnit.tenantsData.find((tenant)=> tenant.id === rentalPayment.tenantId);
            tenant = dataFound ? {...dataFound, rentalUnitName: rentalUnit.name} : tenant ? tenant : null;
          });
          rentalPayments.push({
            ...rentalPayment,
            tenant
          });
        }
      });
      this.setState({rentalPayments, stopOffsetChange: false, allCheckBox: response.result.length === allCheckedRentalPayments});
    }else{
      this.setState({stopOffsetChange: true});
    }
    this.setState({fetchLoader: false, listLoader: false}, ()=> this.loadTransactionsThenDownload());
  }

  loadTransactionsThenDownload = async () => {
    const { rentalPayments, selectedTenant } = this.state;
    try {
      const { byRentalPaymentId, failed } = await fetchTransactionsForRentalPayments({
        propertyId: this.props.propertySelected?.id,
        rentalPayments: rentalPayments.filter((rentalPayment) => selectedTenant.includes(rentalPayment.tenantId)),
      });
      this.setState({ transactionsByRentalPaymentId: byRentalPaymentId, transactionsIncomplete: failed > 0 });
    } catch (error) {
      console.log('loadTransactionsThenDownload: ', error);
      this.setState({ transactionsIncomplete: true });
    }
    setTimeout(() => {
      this.downloadPdfFromServer();
    }, 1000);
  }

  // Detail row under a rental payment that has assigned bank transactions: a captioned inner table
  // (Buchungsdatum, Sender / Empfänger, Verwendungszweck, Betrag) spanning the whole width.
  transactionDetailRow = (rentalPayment) => {
    const transactions = this.state.transactionsByRentalPaymentId[rentalPayment.id] || [];
    if (transactions.length === 0) return null;
    const format = (value) => accounting.formatMoney(value || 0, { symbol: "€",  format: "%v %s", precision: 2, thousand: '.', decimal: ',' });
    const head = this.transactionHeadCellStyling;
    const body = this.transactionBodyCellStyling;
    const total = transactions.reduce((sum, transaction) => sum + (transaction.amount || 0), 0);
    // With a single transaction there is no Summe row under it, so its bottom line goes.
    const lastCell = transactions.length === 1 ? {...body, borderBottom: 'none'} : body;
    return (
      <TableRow style={{pageBreakInside: 'avoid'}}>
        <TableCell colSpan={7} style={{...this.tableBodyCellStyling, background: '#F8F8FC', padding: '1.5mm 2mm 2mm 5mm', lineHeight: '12px'}}>
          <div style={{color: '#0e0e1d', fontSize: '6.5pt', fontWeight: '500', marginBottom: '1mm'}}>
            {`Zugeordnete Bankumsätze (${transactions.length})`}
          </div>
          <table style={{width: '100%', borderCollapse: 'collapse', background: '#FFFFFF', border: '1px solid #DADAE6'}}>
            <thead>
              <tr>
                <th style={{...head, width: '15%'}}>Buchungsdatum</th>
                <th style={{...head, width: '27%'}}>Sender / Empfänger</th>
                <th style={head}>Verwendungszweck</th>
                <th style={{...head, width: '14%', textAlign: 'right'}}>Betrag</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction, index) => {
                const cell = index === transactions.length - 1 ? lastCell : body;
                return (
                  <tr key={transaction.id}>
                    <td style={{...cell, whiteSpace: 'nowrap'}}>{transaction.bankBookingDate ? dayjs(transaction.bankBookingDate).format('DD.MM.YYYY') : '-'}</td>
                    <td style={cell}>{transaction.counterpartName || '-'}</td>
                    <td style={cell}>{transaction.purpose || '-'}</td>
                    <td style={{...cell, textAlign: 'right', whiteSpace: 'nowrap'}}>{format(transaction.amount)}</td>
                  </tr>
                );
              })}
              {transactions.length > 1 &&
              <tr>
                <td colSpan={3} style={{...body, borderBottom: 'none', textAlign: 'right', fontWeight: '500'}}>Summe</td>
                <td style={{...body, borderBottom: 'none', textAlign: 'right', fontWeight: '500', whiteSpace: 'nowrap'}}>{format(total)}</td>
              </tr>}
            </tbody>
          </table>
        </TableCell>
      </TableRow>
    );
  }

  evaluateRentalPayments=()=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rentalPayments/evaluateRentalPayments',
      'POST',
      {propertyId: this.props.propertySelected.id},
      null,
      false,
      true,
      false,
      this,
      'handleEvaluateRentalPayments',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleEvaluateRentalPayments(response){
    this.getRentalPayments();
  }


  getTableLabels = () => {
    return (
      <TableRow>
        <TableCell style={this.tableHeadCellStyling}>{'Mieter'}</TableCell>
        <TableCell style={this.tableHeadCellStyling}>{'Mieteinheit'}</TableCell>
        <TableCell style={this.tableHeadCellStyling}>{'Monat'}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{'Vertragsmiete'}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{'Zahlungseingang'}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{'Erhaltene Kaltmiete'}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{'Erhaltene Vorauszahlung'}</TableCell>
      </TableRow>
    );
  };

  downloadPdfFromServer=()=>{
        console.log('downloadPdfFromServer:');
        const data = new FormData();
        const closeWindow = ()=> {
            var allowDownloadSafari = document.getElementById('allow_download');
            allowDownloadSafari.style.display = browserName === 'Safari' && 'block'; 
            var spinner = document.getElementById('hh_loader_spinner');
            browserName !== 'Safari' ? loader(false) : spinner.style.display = 'none';
            browserName !== 'Safari' && window.close();
        }
        let html = document.getElementById('divToPrint0');
        let doc = document.implementation.createHTMLDocument("New Document");
        try {
          const {accountData, propertySelected} = this.props;
          doc.body.appendChild(html);
          const blob = new Blob([doc.documentElement.innerHTML], {
            type: 'text/html'
           });
           
          const fileName = `tenantExportPdf-${this.props.propertySelected.name}-${new Date().valueOf()}}`;
          let file = new File([blob], fileName);
          file.originalname = fileName;
          console.log('downloadPdfFromServer: ', file);

          data.append('file', file);
          let footer = `${accountData.addressCompany && (accountData.addressCompany + ', ')}${accountData.addressStreet && (accountData.addressStreet + ',')} ${(accountData.addressZipCode)} ${accountData.addressCity}`;
          console.log('propertySelectedsadfadg: ', propertySelected);
          if(propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled){
            const {propertyOwner} = propertySelected;
            footer = `${propertyOwner?.name && (propertyOwner?.name + ', ')}${propertyOwner?.street && (propertyOwner?.street + ', ')}${(propertyOwner?.postalCode)} ${propertyOwner?.city}`;
            data.append('footer', footer);
          }else{
            data.append('footer', footer);
          }
          let url = `https://${checkEnvironment()}.hellohousing.de/api/reporting-api/pdf`;
          fetch(url,
            {
              method: 'POST',
              body: data,
              headers: {
                Authorization: Autoload.Utils.getAuthToken(),
              }
            }).then((response)=> {
              if(response.status === 200){
                response.blob()
                .then(data => {
                  this.convertBlobToArrayBuffer(data).then((value)=> {
                    const pdfBytes = this.mergePdfs([value]);
                    const {tenantEditView} = this.state;
                    const {propertySelected, formData} = this.props;
                    pdfBytes.then(function(result) {
                      var blob = new Blob([result], {type: "application/pdf"});
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      //var fileName = reportName;
                      link.download = `Mieteingang ${tenantEditView ? formData?.name : propertySelected?.propertyAddress ? `${propertySelected?.propertyAddress}, ${propertySelected?.propertyZipCode} ${propertySelected?.propertyCity}` : propertySelected.name} ${moment().format('DD.MM.YYYY')}.pdf`;
                      //link.download = 'testing_123.pdf';
                      
                      link.click();
                      
                      setTimeout(() => {
                          closeWindow();
                      }, 500);
                  })
                  })
  
                  //download progress
                  // var a = document.createElement("a");
                  // document.body.appendChild(a);
                  // let url = window.URL.createObjectURL(data);
                  // a.href = url;
                  // a.download = `Export-Mieteraufstellung-${this.props.propertySelected?.propertyAddress ? `${this.props.propertySelected?.propertyAddress}_${this.props.propertySelected?.propertyZipCode}_${this.props.propertySelected?.propertyCity}` : this.props.propertySelected.name}-${moment().format('YYYYMMDD')}.pdf`;
                  // a.click();
                  // window.URL.revokeObjectURL(url);
                  // setTimeout(() => {
                  //   closeWindow();
                  // }, 500);
                })
              }else{
                errorHandlingForPDF(response, this.props.profileData, url);
              }
            });
        } catch (e) {
          console.log('downloadPdfFromServer: ', e);
        }
  }

  async convertBlobToArrayBuffer(blob) {
    const buf = await blob.arrayBuffer();
    return buf;
  }

  async mergePdfs(pdfsToMerge) {
    console.log('mergePdfs', pdfsToMerge);
    const mergedPdf = await PDFDocument.create();
    const font = await mergedPdf.embedStandardFont(StandardFonts.Helvetica);

    const createInnerPromise = async (arrayBuffer) => {
      const pdf = await PDFDocument.load(arrayBuffer);
      return await mergedPdf.copyPages(pdf, pdf.getPageIndices());
    };

    const outerPromise = pdfsToMerge.map((arrayBuffer) => {
      const innerPromise = createInnerPromise(arrayBuffer);
      return innerPromise;
    });

    const resultOuterPromise = await Promise.all(outerPromise);

    let count = 0;
    let totalPages = 0;
    resultOuterPromise.forEach((pageArray, i) => {
      pageArray.forEach((page, index) => {
        totalPages = totalPages + 1;
      })
    });
    resultOuterPromise.forEach((pageArray, i) => {
      pageArray.forEach((page) => {
        const { width, height } = page.getSize();
        page.drawText(`Seite ${count+1} von ${totalPages}`, {
          x: width - 74,
          y: height - 27,
          size: 6,
          color: rgb(0.5, 0.5, 0.5),
        });
        //add footer
        // var text = `${this.props.accountData.addressCompany && (this.props.accountData.addressCompany + ', ')}${this.props.accountData.addressStreet && (this.props.accountData.addressStreet + ',')} ${(this.props.accountData.addressZipCode)} ${this.props.accountData.addressCity}`;
        // const textWidth = font.widthOfTextAtSize(text, 8);
        // page.drawText(text, {
        //   x: page.getWidth() / 2 - textWidth / 2,
        //   y: height - (height-30),
        //   size: 8,
        //   color: rgb(0.5, 0.5, 0.5)
        // });
        //
        mergedPdf.addPage(page);
        count = count + 1;
      });
    });

    return (await mergedPdf.save()).buffer;
  }

  tableDataRow=(rentalUnit, tenant, rent)=>{
    return (
      <TableRow>
        <TableCell style={{...this.tableBodyCellStyling, ...{width: rentalUnit.name.length > 22 ? '100px' : '87.75px', wordBreak: 'break-word'}}}>
          {rentalUnit.name}
        </TableCell>
        <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
          {formatNumber(rentalUnit.size, false)}
        </TableCell>
        <TableCell style={{...this.tableBodyCellStyling, ...{width: tenant.name.length > 22 ? '100px' : '87.75px', wordBreak: 'break-word'}}}>
          {tenant.name}
        </TableCell>
        <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
          {tenant.in}
        </TableCell>
        <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
          {tenant.out}
        </TableCell>
        <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
          {rent !== null ? rent.netRent !== 0 ? formatNumber(rent.netRent, true) : '0,00 €' : '-'}
        </TableCell>
        <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
          {rent !== null ? rent.prePayments !== 0 ? formatNumber(rent.prePayments, true) : '0,00 €' : '-'}
        </TableCell>
        <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
          {rent !== null ? (rent.prePayments + rent.netRent) !== 0 ? formatNumber(rent.prePayments + rent.netRent, true) : '0,00 €' : '-'}
        </TableCell>
      </TableRow>
    )
  }

  getTableBody = () => {
    const {rentalPayments, selectedTenant, order, orderBy} = this.state;

    return(rentalPayments.sort((a,b)=> orderBy === 'Mieter' ? (order === 'asc' ?  a.tenant?.fullName.toLowerCase().localeCompare(b.tenant?.fullName.toLowerCase()) : b.tenant?.fullName.toLowerCase().localeCompare(a.tenant?.fullName.toLowerCase())) 
    : orderBy === 'Mieteinheit' ? (order === 'asc' ? a.tenant.rentalUnitName.toLowerCase().localeCompare(b.tenant.rentalUnitName.toLowerCase()) : b.tenant.rentalUnitName.toLowerCase().localeCompare(a.tenant.rentalUnitName.toLowerCase())) 
    : orderBy === 'Monat' ? (order === 'asc' ? dayjs(a.rentalMonth) - dayjs(b.rentalMonth) : dayjs(b.rentalMonth) - dayjs(a.rentalMonth))
    : orderBy === 'Vertragsmiete' ? (order === 'asc' ? (a.expectedNetRent + a.expectedAdvancePayment) - (b.expectedNetRent + b.expectedAdvancePayment) : (b.expectedNetRent + b.expectedAdvancePayment) - (a.expectedNetRent + a.expectedAdvancePayment))
    : orderBy === 'Zahlungseingang' && (order === 'asc' ? (a.receivedNetRent + a.receivedAdvancePayment) - (b.receivedNetRent + b.receivedAdvancePayment) : (b.receivedNetRent + b.receivedAdvancePayment) - (a.receivedNetRent + a.receivedAdvancePayment))).map((rentalPayment)=>{
        if(selectedTenant.find((tenantId)=> tenantId === rentalPayment.tenantId) !== undefined){
            return (
              <React.Fragment key={rentalPayment.id}>
              <TableRow style={{background: '#FFFFFF'}}>
                <TableCell width={'25%'} style={{...this.tableBodyCellStyling, ...{wordBreak: 'break-word'}}}>
                  {rentalPayment.tenant?.fullName}
                </TableCell>
                <TableCell width={'12%'} style={{...this.tableBodyCellStyling, ...{wordBreak: 'break-word'}}}>
                  {rentalPayment.tenant?.rentalUnitName}
                </TableCell>
                <TableCell width={'12%'} style={this.tableBodyCellStyling}>
                  {dayjs(rentalPayment.rentalMonth).locale('de').format('MMM YYYY')}
                </TableCell>
                <TableCell width={'12%'} style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
                  <span>{(rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment) ? accounting.formatMoney((rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment), { symbol: "€",  format: "%v %s", precision: 2, thousand: '.', decimal: ',' }) : '0,00 €'}</span> 
                </TableCell>
                <TableCell width={'12%'} style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
                  {(rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) ? accounting.formatMoney((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment), { symbol: "€",  format: "%v %s", precision: 2, thousand: '.', decimal: ',' }) : '0,00 €'}
                </TableCell>
                <TableCell width={'12%'} style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
                  <span>{accounting.formatMoney(rentalPayment.receivedNetRent || 0, { symbol: "€",  format: "%v %s", precision: 2, thousand: '.', decimal: ',' })}</span> 
                </TableCell>
                <TableCell width={'12%'} style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>
                  <span>{accounting.formatMoney(rentalPayment.receivedAdvancePayment || 0, { symbol: "€",  format: "%v %s", precision: 2, thousand: '.', decimal: ',' })}</span>
                </TableCell>
              </TableRow>
              {this.transactionDetailRow(rentalPayment)}
              </React.Fragment>
            )
          //}
        }
      })
    )
  };

  getTotalRow = () => {
    const { rentalPayments, selectedTenant, order, orderBy } = this.state;

    const filteredPayments = rentalPayments.filter((rp) => 
      selectedTenant.includes(rp.tenantId)
    );

    const totals = filteredPayments.reduce((acc, curr) => {
      acc.expectedTotal += (curr.expectedNetRent + curr.expectedAdvancePayment) || 0;
      acc.receivedNet += curr.receivedNetRent || 0;
      acc.receivedAdvance += curr.receivedAdvancePayment || 0;
      acc.receivedTotal += (curr.receivedNetRent + curr.receivedAdvancePayment) || 0;
      return acc;
    }, { expectedTotal: 0, receivedNet: 0, receivedAdvance: 0, receivedTotal: 0 });

    const format = (value) => accounting.formatMoney(value, { 
      symbol: "€", 
      format: "%v %s", 
      precision: 2, 
      thousand: '.', 
      decimal: ',' 
    });

    return (
      <TableRow style={{ background: '#FFFFFF' }} key={'total_row'}>
        <TableCell style={{ ...this.tableHeadCellStyling, textAlign: 'right' }} colSpan={3}>
          <span>Gesamt</span>
        </TableCell>
        <TableCell style={{ ...this.tableBodyCellStyling, textAlign: 'right' }}>
          {format(totals.expectedTotal)}
        </TableCell>
        <TableCell style={{ ...this.tableBodyCellStyling, textAlign: 'right' }}>
          {format(totals.receivedTotal)}
        </TableCell>
        <TableCell style={{ ...this.tableBodyCellStyling, textAlign: 'right' }}>
          {format(totals.receivedNet)}
        </TableCell>
        <TableCell style={{ ...this.tableBodyCellStyling, textAlign: 'right' }}>
          {format(totals.receivedAdvance)}
        </TableCell>
      </TableRow>
    );
  };

  render() {
    const { allRents, customImageBase64, tenantEditView, transactionsIncomplete } = this.state;
    const { rentalUnits, propertySelected, formData, isLogoHidden } = this.props;

    console.log('isLogoHidden_562673: ', isLogoHidden);
    return (
      <div
      style={{fontFamily: 'Inter,sans-serif'}}
      id={'mainDiv'}>
          <div
            ref={ref}
            id={'divToPrint0'}
            style={{fontFamily: 'Inter,sans-serif', maxWidth: '186mm', width: '100%',}}
          >
            {isLogoHidden === false ?
            <div style={{ marginBottom: 48 }}>
              <img src={this.props.companyLogoEnable === 'UserDefined' ? customImageBase64 !== null ? customImageBase64 : Logo : Logo} id='logo' alt="logo" style={{height: '56px'}}/>
            </div>
            :
            <div style={{ marginBottom: 48 }}/>}
            <span style={{fontWeight: '500', fontSize: '17pt'}}>{`Mieteingang ${propertySelected?.propertyAddress ? `${propertySelected?.propertyAddress}, ${propertySelected?.propertyZipCode} ${propertySelected?.propertyCity}` : propertySelected.name}${tenantEditView ? ` (${formData?.name})` : ''} (${moment().format('DD.MM.YYYY')})`}</span>
            <TableContainer component={Paper} style={{marginTop: '50px', background: 'transparent'}}>
              <Table style={{borderCollapse: 'collapse', width: '100%'}}>
                <TableHead>
                  {this.getTableLabels()}
                </TableHead>
                <TableBody>
                  {this.getTableBody()}
                  {this.getTotalRow()}
                </TableBody>
              </Table>
            </TableContainer>
            {transactionsIncomplete &&
            <p style={{fontSize: '7pt', color: '#727293', marginTop: '3mm'}}>
              Hinweis: Einige zugeordnete Bankumsätze konnten nicht geladen werden; die Aufstellung der Bankumsätze ist möglicherweise unvollständig.
            </p>}
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
    rentalUnits: state.tenantDataReducer.rentalUnits,
    accountData: state.generalReducer.accountData,
    companyLogoEnable: state.generalReducer.companyLogoEnable,
    formData: state.tenantDataReducer.addEditFormData,
    isLogoHidden: state.generalReducer.isLogoHidden,
    profileData: state.generalReducer.profile
  };
};

export default connect(mapStateToProps)(RentalPaymentsPdfTemplate);
